<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        height: '70%',
        color: '#fff',
    }" class="addressPopup">
        <div class="network_container">
            <div class="popTitle">{{ $t('withdraw.chooseNetwork') }}</div>
            <div v-for="(item, index) in networkList" :key="index">
                <network-card :channel="item?.channel" :channelName="item?.channelName" @click="selectNetwork(item)"
                    :instructions="item?.instructions" />
            </div>
        </div>

    </van-popup>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import NetworkCard from './networkCard.vue';
import { NetworkChannelItem } from '@/view/withdraw/supportScript';
const props = defineProps<{
    networkList: NetworkChannelItem[]
}>()
const emits = defineEmits(['selectNetwork'])
const show = ref(false);

const openPopup = () => {
    show.value = true;
}

const closePopup = () => {
    show.value = false;
}

const selectNetwork = (network: any) => {
    emits('selectNetwork', network)
}

defineExpose({
    openPopup,
    closePopup
})
</script>
<style scoped>
.addressPopup {
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    border: 0.5px solid rgba(255, 255, 255, 0.15) !important;
    background: #312734 !important;
    opacity: 0.8 !important;
    box-shadow: inset 0px 2px 0px 0px #e150a4 !important;
}

::-webkit-scrollbar {
    display: none;
}

.van-overlay {
    backdrop-filter: blur(5px);
}

.network_container {
    padding: 15px 15px 85px;
}

.popTitle {
    font-size: 16px;
    display: flex;
    text-align: center;
    justify-content: center;
    padding: 15px;
}
</style>